export default function MessageBubble({ msg }) {
  return (
    <div className={`bubble-row ${msg.role}`}>
      <div className="bubble">{msg.content}</div>
    </div>
  );
}
